<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M20.0131 4H3.54254C2.56607 4 1.77783 4.77308 1.77783 5.73077V17.2692C1.77783 18.2269 2.56607 19 3.54254 19H20.0131C20.9896 19 21.7778 18.2269 21.7778 17.2692V5.73077C21.7778 4.77308 20.9896 4 20.0131 4ZM20.6014 17.2692C20.6014 17.5808 20.3425 17.8462 20.0131 17.8462H3.54254C3.21313 17.8462 2.9543 17.5808 2.9543 17.2692V10.9231H20.6014V17.2692ZM2.9543 7.46154V5.73077C2.9543 5.40769 3.21313 5.15385 3.54254 5.15385H20.0131C20.3425 5.15385 20.6014 5.40769 20.6014 5.73077V7.46154H2.9543Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
